import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import BookingItem from './BookingItem';

const BookingList = ({ active, data }) => {
  const { t } = useTranslation();
  const properData = useMemo(() => {
    const arr = Array.isArray(data) ? [...data] : [];
    if (active) {
      return arr.sort((a, b) => {
        if (a.from_date < b.from_date) return -1;
        if (a.from_date > b.from_date) return 1;
        return 0;
      });
    }
    const expiredArr = arr.length > 30 ? arr.slice(0, 30) : arr;
    return expiredArr.sort((a, b) => {
      if (a.from_date < b.from_date) return 1;
      if (a.from_date > b.from_date) return -1;
      return 0;
    });
  }, [active, data]);

  if (!properData.length) {
    return (
      <div style={{ opacity: 0.7 }}>
        {t('MaintainBookings.noBookings', 'No bookings')}
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gap: 16 }}>
      {properData.map((booking) => (
        <BookingItem key={booking.booking_id || booking.id} booking={booking} />
      ))}
    </div>
  );
};

export default BookingList;
